module.exports = __webpack_public_path__ + "media/images/icons/health-99fae074e25a1ef84f4a8fa38f5886d3.png";